import type { SearchSuggestion } from "@bw/shared/api";

const entityLabels = {
  facilities: "Facility",
  coaches: "Coach",
  classes: "Class",
  open_play: "Drop-in",
  tournaments: "Tournament",
  leagues: "League",
  players: "Player",
  communities: "Community",
} as const;

export function suggestionKey(item: SearchSuggestion): string {
  if (item.intent === "entity")
    return `entity:${item.kind}:${item.entity_id}`;
  if (item.intent === "location")
    return `location:${item.category}:${item.city}:${item.query}`;
  return `category:${item.category}:${item.query}`;
}

export function suggestionTypeLabel(item: SearchSuggestion): string {
  if (item.intent === "entity") return entityLabels[item.kind];
  return item.intent === "location" ? "Location" : "Search";
}

/** One destination contract for Search-page and quick-preview suggestions. */
export function suggestionLink(item: SearchSuggestion): string {
  if (item.intent === "category" || item.intent === "location") {
    const params = new URLSearchParams({ q: item.query });
    if (item.category === "tournaments" || item.category === "leagues") {
      params.set("category", "competitions");
      params.set("competition_type", item.category);
    } else if (item.category !== "all") {
      params.set("category", item.category);
    }
    if (item.intent === "location") params.set("city", item.city);
    return `/search?${params}`;
  }
  switch (item.kind) {
    case "facilities":
      return `/facility/${item.entity_id}`;
    case "coaches":
      return `/coaches/${item.entity_id}`;
    case "classes":
      return item.facility_id
        ? `/classes/${item.facility_id}/${item.entity_id}`
        : `/search?${new URLSearchParams({ q: item.label, category: "classes" })}`;
    case "open_play":
      return `/dropin/${item.entity_id}`;
    case "tournaments":
      return `/tournaments/${item.entity_id}`;
    case "leagues":
      return `/compete/leagues/divisions/${item.entity_id}`;
    case "players":
      return `/players/${item.entity_id}`;
    case "communities":
      return `/community/communities/${item.entity_id}`;
  }
}
